// src/components/IconButton.tsx
import React from "react";

interface IconButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  active?: boolean;
}

const IconButtonV2: React.FC<IconButtonProps> = ({
  icon,
  label,
  onClick,
  active = false,
}) => {
  return (
    <button
      onClick={onClick}
      className={`group flex w-full items-center gap-3 rounded-2xl px-4 py-3 text-left text-sm font-medium transition ${
        active
          ? "bg-primary text-white"
          : "text-slate-600 hover:bg-white hover:text-slate-900"
      }`}
    >
      <span
        className={`flex h-10 w-10 items-center justify-center rounded-xl transition ${
          active
            ? "bg-white/15 text-white"
            : "bg-slate-100 text-slate-500 group-hover:bg-primary/10 group-hover:text-primary"
        }`}
      >
        {icon}
      </span>
      <span className="truncate text-[0.95rem]">{label}</span>
    </button>
  );
};

export default IconButtonV2;
